const statusData = [
  {
    title: "Assigned",
    color: "--assigned",
    key: "assigned",
    id: 3,
    bg_color: "#F8F8F8",
  },
  {
    title: "Not Assigned",
    color: "--assigned",
    key: "un_assigned",
    id: 2,
    bg_color: "#F8F8F8",
  },
  {
    title: "Work-in-progress",
    color: "  --work-in-progress",
    key: "work_in_progress",
    id: 4,
    bg_color: "#F4F8FF",
  },
  {
    title: "Delayed",
    color: "  --delayed",
    key: "delayed",
    id: 6,
    bg_color: "#FFFAEB",
  },
  {
    title: "Blocked",
    color: "--on-hold",
    key: "blocked",
    id: 5,
    bg_color: "#FEF3F2",
  },

  {
    title: "Overdue",
    color: " --over-due",
    key: "over_due",
    id: 7,
    bg_color: "#FFE8E6",
  },
  {
    title: "Completed",
    color: "--completed",
    key: "completed",
    id: 1,
    bg_color: "#ECFDF3",
  },
];

const campaignsStatusData = [
  // {
  //   title: "Draft",
  //   color: "#ffff",
  //   key: "draft",
  //   id: 0,
  // },
  {
    title: "Completed",
    color: "--completed", // green
    key: "completed",
    id: 1,
  },

  {
    title: "Work in Progress",
    color: "--work-in-progress", // blue
    key: "work-in-progress",
    id: 2,
  },
  {
    title: "Dormant",
    color: "--assigned", // grey
    key: "dormant",
    id: 3,
  },
  {
    title: "Action Required",
    color: "--on-hold", // red
    key: "action_required",
    id: 4,
  },
  {
    title: "Not Started",
    color: "--un-assigned", // no color
    key: "not_started",
    id: 5,
  },
];

const brandTypes = [
  { title: "organization", id: 1, color: "#5925DC", bg_color: "#F4F3FF" },
  { title: "product", id: 2, color: "#026AA2", bg_color: "#F0F9FF" },
  { title: "brand", id: 2, color: "#026AA2", bg_color: "#F0F9FF" },
  { title: "service", id: 3, color: "#B54708", bg_color: "#FFFAEB" },
];

const userRoles = [
  {
    label: "Admin",
    value: 2,
    allowedPath: [
      "/campaigns",
      "/task-management",
      "/folder",
      "/dashboard",
      "/account-settings",
    ],
  },
  { label: "Manager", value: 3, allowedPath: ["/campaigns"] },
  {
    label: "User",
    value: 4,
    allowedPath: [
      "/task-management",
      "/folder",
      "/dashboard",
      "/account-settings",
    ],
  },
];

const brandTypesDataMap = new Map(brandTypes.map((item) => [item.title, item]));

// const campaignsStatusDataMap = new Map(
//   statusData.map((item) => [item.id, item])
// );

// Create a Map for fast lookups
const statusMap = new Map(statusData.map((item) => [item.id, item.color]));
// Create a Map for fast lookups
const statusDataMap = new Map(statusData.map((item) => [item.id, item]));

function getStatusColorByKey(key) {
  return statusMap.get(key) || null; // Returns the color if found, otherwise null
}

function getStatusColorById(id) {
  return statusMap.get(id) || null; // Returns the color if found, otherwise null
}

function getStatusById(id) {
  return statusDataMap.get(id) || null; // Returns the object if found, otherwise null
}
function getCampaignStatusById(id) {
  // return campaignsStatusDataMap.get(id) || null;
  for (let i = 0; i < campaignsStatusData.length; i++) {
    if (campaignsStatusData[i]?.id == id) return campaignsStatusData[i];
  }
}
function getBrandTypesByTitle(title) {
  return brandTypesDataMap.get(title) || null; // Returns the object if found, otherwise null
}

function getTaskStatusColorByKey(key){
  const data = statusData.find(item => item.key == key);
  return data;
}

const campaignCategoryData = [
  {
    title: "Content Marketing",
    id: 1,
    borderColor: "linear-gradient(248.18deg, #FDC3BF -0.82%, #FEEEED 98.27%)",
    icon: "/contentMarketing.png",
  },
  {
    title: "Digital Marketing",
    id: 2,
    borderColor: `linear-gradient(243.54deg, rgba(127, 154, 72, 0.5) 1.24%, rgba(223, 232, 206, 0.5) 98.66%)`,
    icon: "/digitalMarketing.png",
  },
  {
    title: "Lead Generation",
    id: 3,
    borderColor: `linear-gradient(243.54deg, rgba(0, 83, 122, 0.2) 1.24%, #E5F7FF 98.66%)`,
    icon: "/leadGeneration.png",
  },
  {
    title: "Outbound Marketing",
    id: 4,
    borderColor: `linear-gradient(243.54deg, rgba(110, 79, 99, 0.6) 1.24%, rgba(132, 109, 124, 0.2) 98.66%)`,
    icon: "/outboundMarketing.png",
  },
  {
    title: "Product Marketing",
    id: 5,
    borderColor: `linear-gradient(243.54deg, rgba(208, 192, 169, 0.6) 1.24%, rgba(208, 192, 169, 0.2) 98.66%)`,
    icon: "/productMarketing.png",
  },
  {
    title: "Compliance and Legal",
    id: 6,
    borderColor: `linear-gradient(248.18deg, rgba(124, 16, 246, 0.3) -0.82%, #F4EEFA 98.27%)`,
    icon: "/complianceLegal.png",
  },
  {
    title: "Data and Analytics",
    id: 7,
    borderColor: `linear-gradient(246.02deg, #ECA0F7 -0.14%, #FCF4FE 99.9%)`,
    icon: "/dataAnalytics.png",
  },
  {
    title: "Email Marketing",
    id: 8,
    borderColor: "linear-gradient(247.92deg, #95ACE6 -3.68%, #E6EBF7 99.51%)",
    icon: "/emailMarketing.png",
  },
  {
    title: "Marketing Automation",
    id: 9,
    borderColor: `linear-gradient(248.18deg, #E2E8A8 -0.82%, #F6F9D8 98.27%)`,
    icon: "/marketingAutomation.png",
  },
  {
    title: "Social Media Marketing",
    id: 10,
    borderColor: "linear-gradient(246.02deg, #FBE9A4 -0.14%, #FEF8E1 99.9%)",
    icon: "/socialMediaMarketing.png",
  },
  {
    title: "Strategy and Planning",
    id: 11,
    borderColor: `linear-gradient(247.92deg, rgba(108, 228, 239, 0.8) -3.68%, #DBF2F5 99.51%)`,
    icon: "/strategyPlanning.png",
  },
  {
    title: "Technology and Tools",
    id: 12,
    borderColor: `linear-gradient(247.92deg, #C2CBD4 -3.68%, #F1F1F1 99.51%)`,
    icon: "/technologyTools.png",
  },
];

const getCategoryStylesById = (id) => {
  return campaignCategoryData.find((category) => category.id === id);
};


const getCategoryStylesByTitle = (title) => {
  return campaignCategoryData.find(category => category.title == title);
}

const priorityData = [
  { label: "Priority 1", value: 1 },
  { label: "Priority 2", value: 2 },
  { label: "Priority 3", value: 3 },
  { label: "Priority 4", value: 4 },
];

const fileCategoryThumbnails = {
  documents: {
    pdf: "/pdf.png",
    doc: "/doc.png",
    docx: "/doc.png",
    txt: "/doc.png",
    csv: "/csv.png", // CSV as Excel
    rtf: "/doc.png",
  },
  spreadsheets: {
    xlsx: "/csv.png",
    csv: "/csv.png", // CSV treated as Excel
  },
  videos: {
    mp4: "/mp4.png",
    mov: "/mp4.png",
    avi: "/mp4.png",
    mkv: "/mp4.png",
    webm: "/mp4.png",
  },
  images: {
    jpg: "/png.png",
    jpeg: "/png.png",
    png: "/png.png",
    gif: "/png.png",
    bmp: "/png.png",
  },
  audio: {
    mp3: "/default.png",
    wav: "/audio.png",
    flac: "/audio.png",
    ogg: "/audio.png",
  },
};

// Function to dynamically fetch the correct thumbnail based on file extension
function getThumbnail(fileExtension) {
  // Normalize the extension to lowercase
  const ext = fileExtension.toLowerCase();

  // Debugging log

  // Check each category for the extension
  for (const category in fileCategoryThumbnails) {
    if (fileCategoryThumbnails[category][ext]) {
      return fileCategoryThumbnails[category][ext];
    }
  }
  return "/default.png";
}

export {
  statusData,
  getStatusColorByKey,
  getCategoryStylesById,
  getStatusColorById,
  priorityData,
  getStatusById,
  getThumbnail,
  campaignCategoryData,
  campaignsStatusData,
  getCampaignStatusById,
  getBrandTypesByTitle,
  userRoles,
  getCategoryStylesByTitle,
  getTaskStatusColorByKey
};
